/* Aeko Linen — small progressive enhancements */
(function () {
  'use strict';

  // Mobile menu
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var header = toggle.closest('.site-header');
    var open = header.classList.toggle('menu-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Testimonials marquee pause button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-marquee-toggle]');
    if (!btn) return;
    var marquee = document.getElementById(btn.getAttribute('aria-controls'));
    if (!marquee) return;
    var paused = marquee.classList.toggle('is-paused');
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    btn.querySelector('[data-label]').textContent = paused ? btn.dataset.playLabel : btn.dataset.pauseLabel;
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    var next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Variant picker
  function initProduct(form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var submit = form.querySelector('[type="submit"]');
    var priceEl = document.querySelector('[data-product-price]');
    var labels = { add: submit.dataset.addLabel, soldOut: submit.dataset.soldOutLabel, unavailable: submit.dataset.unavailableLabel };

    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-index]')) return;
      var selected = [];
      form.querySelectorAll('[data-option-group]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      if (!match) {
        submit.disabled = true;
        submit.textContent = labels.unavailable;
        return;
      }
      idInput.value = match.id;
      submit.disabled = !match.available;
      submit.textContent = match.available ? labels.add : labels.soldOut;
      if (priceEl) priceEl.textContent = match.price_formatted;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    });
  }
  document.querySelectorAll('[data-product-form]').forEach(initProduct);
})();
